<div class="report-popup">
    <div class="popup-header">
        <h2 mat-dialog-title>Impresi&oacute;n de Despachos de Coordinadores</h2>
    </div>

    <div class="popup-content" mat-dialog-content>
        <div class="selected-name">
            {{ data.coordinador }}
        </div>

        <div class="date-row">
            <div class="date-field">
                <label>Desde</label>
                <mat-form-field appearance="outline">
                    <input matInput [matDatepicker]="dateFromPicker" [(ngModel)]="dateFrom" readonly (click)="dateFromPicker.open()">
                    <mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateFromPicker></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="date-field">
                <label>Hasta</label>
                <mat-form-field appearance="outline">
                    <input matInput [matDatepicker]="dateToPicker" [(ngModel)]="dateTo" readonly (click)="dateToPicker.open()">
                    <mat-datepicker-toggle matSuffix [for]="dateToPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateToPicker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

        <div class="validation-message" *ngIf="validationMessage">
            {{ validationMessage }}
        </div>
    </div>

    <div class="popup-footer" mat-dialog-actions align="end">
        <button type="button" class="accept-button" (click)="aceptar()">Aceptar</button>
        <button type="button" class="cancel-button" (click)="cancelar()">Cancelar</button>
    </div>
</div>
